import { noApostropheOrPercentRegex, isDecimalWithinPrecision } from './config'

export const isRuleValueValid = value =>
    value !== 'null' &&
    value !== 'undefined' &&
    !!(value && typeof value === 'string' && value.trim().length > 0)

const isValidNumericList = (value, type) => {
    if (!value || typeof value !== 'string') return false

    const items = value.split(',').map(item => item.trim()).filter(item => item.length > 0)
    if (items.length === 0) return false

    const itemRegex = type === 'int'
        ? /^-?\d+$/ 
        : /^-?\d+(\.\d+)?$/

    return items.every(item => itemRegex.test(item))
}

export const ruleValidation = (rule, inputtype, dataType, precision, scale, multipartValidation = false) => {
    const { value, operator } = rule

    const isNoValueOperator = ['null', 'notNull'].includes(operator)
    if (isNoValueOperator) {
        return {
                valid: true,
                value: value,
                reasons: [],
            }
    }

    const isInOperator = operator === 'in' || operator === 'notIn'
    const isNumericType = inputtype === 'number' || ['int', 'decimal', 'double', 'real', 'float'].includes(dataType)

    if (isInOperator && isNumericType) {
        if (!isRuleValueValid(value)) {
            return {
                valid: false,
                value: value,
                reasons: ['Required field'],
            }
        }

        if (value.trim().endsWith(',') && value.trim().length > 1) {
            return {
                valid: true,
                value: value,
                reasons: [],
            }
        }

        if (!isValidNumericList(value, dataType)) {
            const errorMessage = dataType === 'int'
                ? 'Enter integers separated by commas (ex: 1, 2, 3)'
                : 'Enter numbers separated by commas (ex: 1.5, 2.3, 4.0)'

            return {
                valid: false,
                value: value,
                reasons: [errorMessage],
            }
        }

        return {
            valid: true,
            value: value,
            reasons: [],
        }
    }

    const isBetweenOperator = rule.operator === 'between' || rule.operator === 'notBetween'
    if (isBetweenOperator || multipartValidation) {
        const ruleValueParts = value.split(',')
        if (
            !isRuleValueValid(ruleValueParts[0]) &&
            isRuleValueValid(ruleValueParts[1])
        ) {
            return {
                valid: isRuleValueValid(ruleValueParts[0]),
                value: value,
                reasons: ['Required field', null],
            }
        }
        if (
            isRuleValueValid(ruleValueParts[0]) &&
            !isRuleValueValid(ruleValueParts[1])
        ) {
            return {
                valid: isRuleValueValid(ruleValueParts[1]),
                value: value,
                reasons: [null, 'Required field'],
            }
        }
        if (
            (!isRuleValueValid(ruleValueParts[0]) &&
                !isRuleValueValid(ruleValueParts[1])) ||
            value === ''
        ) {
            return {
                valid:
                    isRuleValueValid(ruleValueParts[0]) &&
                    isRuleValueValid(ruleValueParts[1]),
                value: value,
                reasons: ['Required field', 'Required field'],
            }
        }
    }

    if (dataType === 'varchar' && !noApostropheOrPercentRegex.test(value)) {
        return {
            valid: false,
            reasons: ['Field cannot contain an apostrophe or percentage sign'],
        }
    }

    if (!isInOperator && (inputtype === 'numeric' || (['decimal', 'double', 'real', 'float'].includes(dataType) && precision !== null && scale !== null))) {
        if (!isDecimalWithinPrecision(value, precision, scale)) {
            return {
                valid: false,
                reasons: [`Value exceeds allowed precision (${precision}, ${scale})`],
            }
        }
    }

    return {
        valid: isRuleValueValid(value),
        value: value,
        reasons: ['Required field'],
    }
}

const noBracketsRegex = /^[^[\]]*$/
const noSingleQuotesRegex = /^[^']*$/

export { noBracketsRegex, noSingleQuotesRegex }
